import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import ReactDatatable from "@ashvin27/react-datatable";
import InputField from "../components/UI/InputField";
import SpanField from "../components/UI/SpanField";
import axios from "axios";
import { Popup } from '../components/UI/Popup';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    getPharmacyList,
    getAllPharmacyDrugs,
    getAllPharmacyItemList,
    getAllPharmacyVendorList,
    addPharmacy,
    addVendor,
    addExpiryBreakageReturnData,
    updatePharmacy,
    deletePharmacy,
    getTimeoutbycategory,
    searchPharmacy,
    hospitalpharmacyimport,
    getitemlistforPharmacyDrug,
    getgststatebyVendorname,
    getPharmacyShortDetail,
    openingstockimport,
    getBatchandExpDateBydrugname,
    getalldetailsBygenericnameandbatchno,
    getvendorshortdetailsbyVendorname
} from "../config/url.json";
import { CONFIG } from "../config/data";
import Select from "react-select";
import Header from "../components/container/layout/pharmacy/Header";
import BusinessUserSideBar from "../components/container/SideBar";
import Validation from "../actions/Validation";
import { withRouter } from "react-router-dom";
import IdleTimer from 'react-idle-timer';
import { IdleTimeOutModal } from '../components/container/modal/IdleModal';
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import Tooltip from '@mui/material/Tooltip';
import Label from "../components/UI/Label";
import PharmacyListExport from "./Business/PharmacyListExport";
import PharmacyListTemplate from "./Business/PharmacyListTemplate";
import LoadingSpinner from "../components/UI/LoadingSpinner";
import readXlsxFile from 'read-excel-file';
import { Popupinfo } from "../components/UI/Popupinfo";
import FooterSection from "../components/UI/FooterSection";
import { renameKey } from "../constants/globalLevelFunctions";
import DatePicker from "react-date-picker";
import OpeningStockTemplate from "./OpeningStockTemplate";
import { Link } from 'react-router-dom';
import PurchaseReturnSelectModal from "./PurchaseReturnSelectModal";
var converter = require("number-to-words");

function mapStateToProps(state) {
    return {
        appdata: state.AppData,
        userdata: state.AuthReducer.user,
        access_token: state.AuthReducer.access_token,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        logout: () => dispatch({ type: "SET_LOGOUT" }),
    };
}
const google = window.google;
const onlineOptions = [{ value: 1, label: "Yes" }, { value: 0, label: "No" }];
let record = {
    s_no: "",
    drug_id: "",
    generic_name: "",
    pack: "",
    batch_no: "",
    manu_date: "",
    exp_date: "",
    hsn_code: "",
    quantity: "",
    free: "",
    p_rate: "",
    mrp: "",
    disc: "",
    sub_total: 0,
    cgst: "",
    sgst: "",
    igst: "",
    total: 0,

};
class ExpiryBreakageDNVoucher extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = React.createRef()
        const hospitaltimeout = this.state;
        this.autocomplete = null;
        this.state = {
            adminstatus: this.props.userdata.adminstatus,
            timeout: hospitaltimeout,
            isTimedOut: false,
            showModal: false,
            showModel: false,
            selectedBatches: [],
            currentBatchinrow: null,
            currentRow: null,
            discountPercentage: '',
            batches: [],
            records: [],
            searchrecords: [],
            addPopup: false,
            actions: "add",
            search_action: false,
            newDatatoAdd: {},
            searchErrorMessage: "",
            purchaseEntryVoucher: {
                drug_name: "",
                // defaultEnterSize: 20,
                records: [],
                supplies: [],
            },

            purchaseReturnData:
            {
                vendor_name: "",
                address: "",
                created_by: "",
                remarks: "",
                expirybreakagereturn_no: "",
                dn_date: new Date(),
                vendorinvoice_no: "",
                invoice_date: "",
                mode: ""

            },
            OpeningStockData: {
                drug_id: "",
                generic_name: "",
                pack: "",
                batch_no: "",
                manu_date: "",
                exp_date: "",
                quantity: "",
                p_rate: "",
                mrp: "",
                sub_total: 0,
                total: 0,
                transaction_type: "",
                transaction_date: "",
                vendor_name: "",
                customer_name: "",
                notes: ""
            },
            totalAmtSec: {

                discAmt: 0,
                cgstAmt: 0,
                sgstAmt: 0,
                igstAmt: 0,
                gstAmt: 0,
                total: 0,
                sub_total: 0,
                totalAmtWords: "",
            },
           /*  totalAmtSec: {

                discAmt: 0,
                cgstAmt: 0,
                sgstAmt: 0,
                gstAmt: 0,
                total: 0,
                sub_total: 0,
                totalAmtWords: "",
                taxrate: 0,
              }, */
              totalTaxAmtSec: {
                cgstAmt5: 0,
                sgstAmt5: 0,
                igstAmt5: 0,
                sub_total5: 0,
                taxAmt5: 0,
                cgstAmt12: 0,
                sgstAmt12: 0,
                igstAmt12: 0,
                sub_total12: 0,
                taxAmt12: 0,
                cgstAmt18: 0,
                sgstAmt18: 0,
                igstAmt18: 0,
                sub_total18: 0,
                taxAmt18: 0,
                sub_total: {
                  5: 0,   // Taxable amount for 5%
                  12: 0,  // Taxable amount for 12%
                  18: 0,  // Taxable amount for 18%
                },
                cgstAmt: {
                  5: 0,   // CGST amount for 5%
                  12: 0,  // CGST amount for 12%
                  18: 0,  // CGST amount for 18%
                },
                sgstAmt: {
                  5: 0,   // SGST amount for 5%
                  12: 0,  // SGST amount for 12%
                  18: 0,  // SGST amount for 18%
                },
                igstAmt: {
                    5: 0,   // SGST amount for 5%
                    12: 0,  // SGST amount for 12%
                    18: 0,  // SGST amount for 18%
                  },
                total: {
                  5: 0,   // Total amount for 5%
                  12: 0,  // Total amount for 12%
                  18: 0,  // Total amount for 18%
                },
              },

            errors: {
                purchaseentry_id: "",
                vendor_name: "",
                address: "",
                created_by: "",
                remarks: "",
                voucher_no: "",
                voucher_date: "",
                vendorinvoice_no: "",
                invoice_date: "",
                poref_no: ""
            },
            tableSuccess: {
                message: "",
                status: ""
            },
            formSuccess: {
                message: "",
                status: ""
            },
            defaultEnterSize: 25,
            records: [],
            supplies: [],
        };
        this.columns = [
            {
                key: "s_no",
                text: "S.No",
                className: "s_no",
                align: "left",
                sortable: true,
            },
            {
                key: "generic_name",
                text: "Item Name",
                className: "generic_name sform-control",
                sortable: true,
                align: "left",
                width: '450px',
                cell: (row, index) => {
                    let obj = {
                        label: record.generic_name,
                        value: record.generic_name,
                    };
                    return (
                        <Select
                            maxMenuHeight={120}
                            isClearable={true}
                            openMenuOnClick={false}
                            className="customselectbilling"
                            name="generic_name"
                            isMandatory={true}
                            value={this.state.supplies.find(option => option.label === row.generic_name)}
                            onChange={this.handleselectChange(index, 'generic_name')}
                            options={this.state.supplies}

                        />

                    );
                },
            },
            {
                key: "pack",
                text: "Pack",
                className: "pack",
                align: "left",
                sortable: true,
                width: '200px',
                cell: (row, index) => row.pack
            },

            {
                key: "batch_no",
                text: "Batch No",
                className: "batch_no",
                sortable: true,
                align: "left",
                width: '200px',
                cell: (row, index) => (
                    <div>
                        {row.generic_name ? (
                            row.batch_no ? (
                                row.batch_no
                            ) : (
                                <Link to="#" onClick={() => this.handleShow(index)}>Select Batch</Link>
                            )
                        ) : null}
                    </div>
                ),
            },

         /*    {
                key: "manu_date",
                text: "Mfg.Date",
                className: "manu_date",
                sortable: true,
                align: "left",
                width: 20,
                cell: (row,index) => {
                    return (
                      <Fragment>
                        <InputField
                                key={index}
                                inputType={"date"}
                                isMandatory={true}
                                name={"manu_date"}
                                controlFunc={this.handleInput(index, 'manu_date')}
                                content={this.formatDateForInput(row.manu_date)} // Format the date for input
                                placeholder={""}
                            />
                         <SpanField
                          classname="text-danger"
                          title={''}
                        /> 
                      </Fragment>
                    );
                  },
              },  */
              {
                key: "exp_date",
                text:"Exp. Date",
                className: "exp_date",
                sortable: true,
                align: "left",
                width: 20,
                cell: (row,index) => {
                    return (
                      <Fragment>
                        <InputField
                          inputType={"date"}
                          isMandatory={true}
                          name={"exp_date"}
                          controlFunc={this.handleInput(index,'exp_date')}
                          content={this.formatDateForInput(row.exp_date)}
                          placeholder={""}
                        />
                         <SpanField
                          classname="text-danger"
                          title={''}
                        /> 
                      </Fragment>
                    );
                  },
              },
            {
                key: "quantity",
                text: "Qty",
                className: "quantity",
                align: "left",
                sortable: true,
                width: '200px',
                cell: (row, index) => {
                    return (
                        <Fragment>
                            <InputField
                                inputType={"number"}
                                name={"quantity"}
                                className="newform-control"
                                controlFunc={this.handleInputChange(index, 'quantity')}
                                content={row.quantity}
                                placeholder={""}
                                step="any"
                            />
                            <SpanField
                                classname="text-danger"
                                title={''}
                            />
                        </Fragment>
                    );
                },
            },
        /*     {
                key: "free",
                text: "Free",
                className: "free",
                align: "left",
                sortable: true,
                width: 200,
                cell: (row, index) => {
                    return (
                        <Fragment>
                            <InputField
                                inputType={"text"}
                                isMandatory={true}
                                name={"free"}
                                controlFunc={this.handleInput(index, 'free')}
                                content={row.free}
                                placeholder={""}
                                step="any"
                            />
                            <SpanField
                                classname="text-danger"
                                title={''}
                            />
                        </Fragment>
                    );
                },
            }, */
            {
                key: "p_rate",
                text: "P.Rate",
                className: "p_rate",
                align: "left",
                sortable: true,
                width: 200,
                cell: (row, index) => {
                    return (
                        <Fragment>
                            <InputField
                                inputType="number"
                                isMandatory={true}
                                name={"p_rate"}
                                controlFunc={this.handleInputChange(index, 'p_rate')}
                                content={row.p_rate}
                                placeholder={""}
                                step="any"
                            />
                            <SpanField
                                classname="text-danger"
                                title={''}
                            />
                        </Fragment>
                    );
                },
            },
            {
                key: "mrp",
                text: "MRP",
                className: "mrp",
                sortable: true,
                align: "left",
                width: 200,
                cell: (row, index) => {
                    return (
                        <Fragment>
                            <InputField
                                inputType={"text"}

                                name={"mrp"}
                                controlFunc={this.handleInput(index, 'mrp')}
                                content={row.mrp}
                                placeholder={""}
                            />
                            <SpanField
                                classname="text-danger"
                                title={''}
                            />
                        </Fragment>
                    );
                },

            },
            {
                key: "disc",
                text: "Disc%",
                className: "disc",
                sortable: true,
                align: "left",
                width: 200,
                cell: (row, index) => {
                    return (
                        <Fragment>
                            <InputField
                                inputType="number"
                                isMandatory={true}
                                name={"disc"}
                                controlFunc={this.handleInputChange(index, 'disc')}
                                content={row.disc}
                                step="any"
                                placeholder={""}
                            />
                            <SpanField
                                classname="text-danger"
                                title={''}
                            />
                        </Fragment>
                    );
                },

            },
            {
                key: "sub_total",
                text: "Sub Total",
                className: "cellTextRight",
                sortable: true,
                align: "left",
                width: 200,
                cell: (row, index) => row.sub_total
            },

            {
                key: "cgst",
                text: "CGST%",
                className: "cellTextRight",
                sortable: true,
                align: "left",
                width: 200,
                cell: (row, index) => row.cgst
            },
            {
                key: "sgst",
                text: "SGST%",
                className: "cellTextRight",
                sortable: true,
                align: "left",
                width: 200,
                cell: (row, index) => row.sgst
            },
            {
                key: "igst",
                text: "IGST%",
                className: "cellTextRight",
                sortable: true,
                align: "left",
                width: 200,
                cell: (row, index) => row.igst
            },
            {
                key: "total",
                text: "Total",
                className: "cellTextRight",
                align: "left",
                sortable: true,
                right: true,
                width: 200,
                cell: (row, index) => row.total
            },
        ];
        this.extraButtons = [
            {
                className: "btn btn-primary buttons-pdf",
                title: "Export TEst",
                children: [
                    <span>
                        <i
                            className="glyphicon glyphicon-print fa fa-print"
                            aria-hidden="true"
                        ></i>
                    </span>,
                ],
                onClick: (event) => {
                    console.log(event);
                },
            },
            {
                className: "btn btn-primary buttons-pdf",
                title: "Export TEst",
                children: [
                    <span>
                        <i
                            className="glyphicon glyphicon-print fa fa-print"
                            aria-hidden="true"
                        ></i>
                    </span>,
                ],
                onClick: (event) => {
                    console.log(event);
                },
                onDoubleClick: (event) => {
                    console.log("doubleClick");
                },
            },
        ];

        this.config = {
            page_size: 25,
            show_first: false,
            show_info: false,
            show_last: false,
            show_filter: false,
            show_length_menu: false,
            show_pagination: false,
            button: {
                excel: false,
                print: false,
            },
        };
        this.searchconfig = {
            page_size: 10,
            length_menu: [10, 20, 50],
            button: {
                excel: false,
                print: false,
            },
        };
        this.searchcolumns = [

            {
                key: "pharmacy_id",
                text: "Pharmacy ID",
                className: "searchpharmacy_id",
                align: "left",
                sortable: true,
                width: 10,
                cell: (record) => {
                    // let obj = {
                    //   label: record.availability,
                    //   value: "Yes" === record.availability ? 1 : 0,
                    // };
                    return (
                        <Fragment>
                            <InputField
                                inputType={"text"}
                                isMandatory={true}
                                name={"searchpharmacy_id"}
                                controlFunc={this.handleInputsearch.bind(this, record)}
                                content={record.searchpharmacy_id}
                                placeholder={""}
                                max={5}
                            />
                            <SpanField classname="text-danger" title={record.pharmacyid_error} />
                        </Fragment>
                    );
                },
            },
            {
                key: "pharmacy_name",
                text: "Pharmacy Name",
                className: "pharmacy_name",
                align: "left",
                sortable: true,
            },
            {
                key: "pharmacy_location",
                text: "Address",
                className: "pharmacy_location",
                sortable: true,
                align: "left",
            },
            {
                key: "phone_number",
                text: "Phone Number",
                className: "phone_number",
                sortable: true,
                align: "left",
            },
            {
                key: "email",
                text: "Email",
                className: "email",
                sortable: true,
                align: "left",
            },
            {
                key: "online_prescription",
                text: "Online Prescription",
                className: "online_prescription",
                sortable: true,
                align: "left",
            },

            {
                key: "action",
                text: "Action",
                className: "action",
                width: 20,
                align: "left",
                sortable: false,
                cell: (record) => {
                    return (
                        <Fragment>
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => this.addRecord(record)}
                                style={{ marginRight: "5px" }}
                            >
                                <i className="fa fa-plus"></i>
                            </button>
                            {/* <button
                className="btn btn-danger btn-sm"
                onClick={() => this.deleteRecord(record)}
              >
                <i className="fa fa-trash"></i>
              </button> */}
                        </Fragment>
                    );
                },
            },
        ];
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)
        this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
    }
    handlePhoneInput = (event) => {
        let pharmacyData = this.state.pharmacyData;
        let errors = this.state.errors;
        pharmacyData.phone_number = event;
        errors.phone_number = "";
        this.setState({ pharmacyData, errors });
    };

    handleClose() {
        this.setState({ showModal: false })
    }

    handleLogout = (e) => {
        this.setState({ showModal: false })
        e.preventDefault();
        localStorage.removeItem("token");
        this.props.logout();
        this.props.history.push("/");
    };

    _onAction(e) {
        // console.log('user did something', e)

        this.setState({ isTimedOut: false })
    }

    _onActive(e) {


        this.setState({ isTimedOut: false })
    }

    _onIdle = (e) => {

        let isTimedOut = this.state.isTimedOut
        let timeout = this.state.timeout;

        if (isTimedOut === false) {
            // console.log("the time is over");
            this.setState({ showModal: true })
            console.log(this.state.showModal);
            this.idleTimer.reset();
            this.setState({ isTimedOut: true })

        }
        if (isTimedOut === true) {
            localStorage.removeItem("token");
            this.props.logout();
        }
    }
    /* 
      handleInput =(index,record) => {
        console.log(e);
        console.log(index);
        console.log(record);
        record[e.target.name] = e.target.value;
      }; */

    handleAdd = (e) => {
        let data = this.state.purchaseReturnData;
        let errors = this.state.errors;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (

            name === "vendor_name" ||
            name === "address" ||
            name === "created_by" ||
            name === "remarks"

        ) {
            this.validateMaxLength(name, value, max);
        } else {
            data[name] = value;
            errors[name] = ""
        }
        this.setState({ purchaseReturnData: data, errors, searchErrorMessage: "" });
    };

    handleInput = (index, field) => (event) => {
        const { value } = event.target;
        const records = [...this.state.records]; // Create a copy of the records
        records[index][field] = value; // Update the specific field for the specific index
        // console.log(value);
        //  console.log(index,field);
        console.log(records);
        this.setState({ records }); // Update the state with the new records
    };

    handleDatePickerChange = (date, field) => {
        const offsetDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));

        this.setState(prevState => ({
            purchaseReturnData: {
                ...prevState.purchaseReturnData,
                [field]: offsetDate, // Update the specific expiry date field
            },
        }));
    };

    handleInputChange = (index, key) => event => {
        let updatedData = [...this.state.records];
        updatedData[index][key] = event.target.value ? parseFloat(event.target.value) : '';
        this.setState({ records: updatedData }, () => {
            this.calculateSubTotal(index);
        });
    };

    calculateSubTotal = (index) => {
        let updatedData = [...this.state.records];
        let p_rate = updatedData[index].p_rate || 0;
        let quantity = updatedData[index].quantity || 0;
        let disc = updatedData[index].disc;
        updatedData[index].sub_total = quantity * (p_rate - ((disc / 100) * p_rate));

        this.setState({ records: updatedData }, () => {

            this.calculateTotal(index);
            this.calculateDiscountAmount(index);
            this.calculateIgstAmount(index);
            this.calculateCgstAmount(index);
            this.calculateSgstAmount(index);
        });
    };

    calculateTotal = (index) => {
        let updatedData = [...this.state.records];
        let sub_total = updatedData[index].sub_total || 0;
        let igst = updatedData[index].igst || 0;
        updatedData[index].total = sub_total + ((igst / 100) * sub_total);
        console.log(igst);
        console.log(updatedData[index].total);
        this.setState({ records: updatedData }, () => {
            this.calculateSection();
            this.calculateTaxAmountSection();
           
        });
    };

    calculateDiscountAmount = (index) => {
        let updatedData = [...this.state.records];
        let p_rate = updatedData[index].p_rate || 0;
        let quantity = updatedData[index].quantity || 0;
        let disc = updatedData[index].disc;
        updatedData[index].discAmt = ((quantity * p_rate) * (disc / 100));
        this.setState({ records: updatedData }, () => {
            this.calculateSection();
            this.calculateTaxAmountSection();
        });
    };
    // calculategstAmount = (index) => {
    //     let updatedData = [...this.state.records];
    //     let igstAmt = updatedData[index].igstAmt;
    //     let cgstAmt = updatedData[index].cgstAmt;
    //     let sgstAmt = updatedData[index].sgstAmt;
    //     updatedData[index].gstAmt = igstAmt+cgstAmt+sgstAmt;
    //     this.setState({ records: updatedData }, () => {
    //         this.calculateSection();
    //         this.calculateTaxAmountSection();
    //     });
    // };
    calculateCgstAmount = (index) => {
        let updatedData = [...this.state.records];
        let cgst = updatedData[index].cgst;
        let sub_total = updatedData[index].sub_total;
        updatedData[index].cgstAmt = (sub_total * (cgst / 100));
        this.setState({ records: updatedData }, () => {
            this.calculateSection();
            this.calculateTaxAmountSection();
        });
    };
    calculateSgstAmount = (index) => {
        let updatedData = [...this.state.records];
        let sgst = updatedData[index].sgst;
        let sub_total = updatedData[index].sub_total;
        updatedData[index].sgstAmt = (sub_total * (sgst / 100));
        this.setState({ records: updatedData }, () => {
            this.calculateSection();
            this.calculateTaxAmountSection();
        });
    };
    calculateIgstAmount = (index) => {
        let updatedData = [...this.state.records];
        let igst = updatedData[index].igst;
        console.log(igst);
        let sub_total = updatedData[index].sub_total;
        updatedData[index].igstAmt = (sub_total * (igst / 100));
        this.setState({ records: updatedData }, () => {
            this.calculateSection();
            this.calculateTaxAmountSection();
        });
    };
    handleInputsearch = (record, event) => {
        record[event.target.name] = event.target.value;
        let max = event.target.max;
        let value = event.target.value;
        if (
            event.target.name === "searchpharmacy_id"

        ) {
            if (value.length > max) {
                const value1 = value.slice(0, max);
                record.pharmacyid_error = "Maximum Length has exceeded.";
                record[event.target.name] = value1;
            }
            else {
                record.pharmacyid_error = "";
                record[event.target.name] = event.target.value;
            }
        }
        this.UpdateSearchColumnChange(record);
    };
     
    handleShow = (index) => {
        const currentRecord = this.state.records[index];
        console.log(currentRecord);
        console.log("curent index", index);
        console.log(this.state.selectedBatches);

        // Create the current batch object
        const currentBatchInRow = {
            batch_no: currentRecord.batch_no || 'Select Batch',
            exp_date: currentRecord.exp_date || 'N/A',
        };
        console.log(currentBatchInRow);

        // Determine the selectedBatch based on the existence of batch_no
        const selectedBatch = currentRecord.batch_no
            ? currentBatchInRow // If batch_no exists, use currentBatchInRow
            : { batch_no: 'Select Batch', exp_date: 'N/A' }; // If not, use default

        // Set the current row index and selected batch in a single setState call
        this.setState({
            currentRow: index,
            selectedBatch: currentBatchInRow, // Set the selected batch based on the logic
            showModel: true,
            selectedBatches: [], // Show the modal
            //batches:[],
        });

    };
    selectBatch = (batches, expdates, quantities,prates,mrps,subtotals,totals,selectedIndex) => {
        const updatedRecords = [...this.state.records];
        const batcheslength = batches.length;
        console.log("Selected Index:", selectedIndex);
        console.log("Batches:", batches);
        console.log("Quantities:", quantities);
        console.log("prates:", prates);
        console.log("old batch length", batcheslength);
        console.log("New batches length", batches.length);
        console.log("First Record:", updatedRecords[0]);
        console.log("Current Row:", this.state.currentRow);
       
        const drug_id = updatedRecords[this.state.currentRow]?.drug_id;
        const drugNameToSet = updatedRecords[this.state.currentRow]?.generic_name;
        const packToSet = updatedRecords[this.state.currentRow]?.pack;
        const storagebin = updatedRecords[this.state.currentRow]?.storage_bin;
        const mrp = updatedRecords[this.state.currentRow]?.mrp;
        const cgst = updatedRecords[this.state.currentRow]?.cgst;
        const sgst = updatedRecords[this.state.currentRow]?.sgst;
        const p_rate = updatedRecords[this.state.currentRow]?.p_rate;
        const sub_total = updatedRecords[this.state.currentRow]?.sub_total;
        const total = updatedRecords[this.state.currentRow]?.total;
        const hsn_code = updatedRecords[this.state.currentRow]?.hsn_code;
        const conversion_factor = updatedRecords[this.state.currentRow]?.conversion_factor;
        console.log("Drug Name to Set:", drugNameToSet);


        if (this.state.currentRow === 0) {
           // const batch_no=updatedRecords[this.state.currentRow]?.batch_no;
            // Loop through each selected batch and update the corresponding row
            batches.forEach((batch, index) => {
                if (updatedRecords[this.state.currentRow + index]) {
                    updatedRecords[this.state.currentRow + index] = {
                        ...updatedRecords[this.state.currentRow + index],
                        batch_no: batch,
                        generic_name: drugNameToSet,
                        drug_id: drug_id,
                        pack: packToSet,
                        storage_bin: storagebin,
                        mrp: mrp,
                        cgst: cgst,
                        sgst: sgst,
                        hsn_code: hsn_code,
                        conversion_factor: conversion_factor,
                        p_rate:p_rate,
                        sub_total:sub_total,
                        total:total,
                        taxrate: (Number(cgst) || 0) + (Number(sgst) || 0),
                    };
                    // this.getalldetailsBygenericnameandbatchno(index,drugNameToSet,batch,new Date());
                    console.log(this.state.currentRow + index);
                    console.log("Updated Record:", updatedRecords[this.state.currentRow + index]);
                   
                }
            });

            expdates.forEach((exp_date, index) => {
                if (updatedRecords[this.state.currentRow + index]) {
                    updatedRecords[this.state.currentRow + index].exp_date = exp_date;
                    console.log("Updated Record with Exp Date:", updatedRecords[this.state.currentRow + index]);
                }
            });
            quantities.forEach((quantity, index) => {
                if (updatedRecords[this.state.currentRow + index]) {
                    updatedRecords[this.state.currentRow + index].quantity = quantity;
                    console.log("Updated Record with quantity:", updatedRecords[this.state.currentRow + index]);
                }
            });
            prates.forEach((p_rate, index) => {
                if (updatedRecords[this.state.currentRow + index]) {
                    updatedRecords[this.state.currentRow + index].p_rate = p_rate;
                    console.log("Updated Record with prate:", updatedRecords[this.state.currentRow + index]);
                }
            });
            mrps.forEach((mrp, index) => {
                if (updatedRecords[this.state.currentRow + index]) {
                    updatedRecords[this.state.currentRow + index].mrp = mrp;
                    console.log("Updated Record with prate:", updatedRecords[this.state.currentRow + index]);
                }
            });
            subtotals.forEach((sub_total, index) => {
                if (updatedRecords[this.state.currentRow + index]) {
                    updatedRecords[this.state.currentRow + index].sub_total = sub_total;
                    console.log("Updated Record with prate:", updatedRecords[this.state.currentRow + index]);
                }
            });
            totals.forEach((total, index) => {
                if (updatedRecords[this.state.currentRow + index]) {
                    updatedRecords[this.state.currentRow + index].total = total;
                    console.log("Updated Record with prate:", updatedRecords[this.state.currentRow + index]);
                }
            });
        }
        else {
            console.log("Current Row:", this.state.currentRow);
            const updatedbatches = this.deleteElementsUpToIndex(batches, this.state.currentRow);
            updatedbatches.forEach((batch, index) => {
                if (updatedRecords[this.state.currentRow + index]) {
                    updatedRecords[this.state.currentRow + index] = {
                        ...updatedRecords[this.state.currentRow + index],
                        batch_no: batch,
                        generic_name: drugNameToSet,
                        drug_id: drug_id,
                        pack: packToSet,
                        storage_bin: storagebin,
                        mrp: mrp,
                        cgst: cgst,
                        sgst: sgst,
                        hsn_code: hsn_code,
                        conversion_factor: conversion_factor,
                        p_rate:p_rate,
                        sub_total:sub_total,
                        total:total,
                        taxrate: (Number(cgst) || 0) + (Number(sgst) || 0),
                    };
                    const updatedexpdates = this.deleteElementsUpToIndex(expdates, this.state.currentRow);
                    updatedexpdates.forEach((exp_date, index) => {
                        if (updatedRecords[this.state.currentRow + index]) {
                            updatedRecords[this.state.currentRow + index].exp_date = exp_date;
                            console.log("Updated Record with Exp Date:", updatedRecords[this.state.currentRow + index]);
                        }
                    });
                    const updatedquantities = this.deleteElementsUpToIndex(quantities, this.state.currentRow);

                    updatedquantities.forEach((quantity, index) => {
                        if (updatedRecords[this.state.currentRow + index]) {
                            updatedRecords[this.state.currentRow + index].quantity = quantity;
                            console.log("Updated Record with quantity:", updatedRecords[this.state.currentRow + index]);
                        }
                    });
                    const updatedprates = this.deleteElementsUpToIndex(prates, this.state.currentRow);

                    updatedprates.forEach((p_rate, index) => {
                        if (updatedRecords[this.state.currentRow + index]) {
                            updatedRecords[this.state.currentRow + index].p_rate = p_rate;
                            console.log("Updated Record with quantity:", updatedRecords[this.state.currentRow + index]);
                        }
                    });
                    const updatedmrps = this.deleteElementsUpToIndex(mrps, this.state.currentRow);
                    updatedmrps.forEach((mrp, index) => {
                        if (updatedRecords[this.state.currentRow + index]) {
                            updatedRecords[this.state.currentRow + index].mrp = mrp;
                            console.log("Updated Record with mrp:", updatedRecords[this.state.currentRow + index]);
                        }
                    });
                    const updatedsubtotals = this.deleteElementsUpToIndex(subtotals, this.state.currentRow);
                    updatedsubtotals.forEach((sub_total, index) => {
                        if (updatedRecords[this.state.currentRow + index]) {
                            updatedRecords[this.state.currentRow + index].sub_total = sub_total;
                            console.log("Updated Record with sub_total:", updatedRecords[this.state.currentRow + index]);
                        }
                    });
                    const updatedtotals = this.deleteElementsUpToIndex(totals, this.state.currentRow);
                    updatedtotals.forEach((total, index) => {
                        if (updatedRecords[this.state.currentRow + index]) {
                            updatedRecords[this.state.currentRow + index].total = total;
                            console.log("Updated Record with total:", updatedRecords[this.state.currentRow + index]);
                        }
                    });
                    console.log(this.state.currentRow + index);
                    console.log("Updated Record:", updatedRecords[this.state.currentRow + index]);
                }
            });
        }

        this.setState({ records: updatedRecords }, () => {
            console.log('Updated Records after Set State:', this.state.records);
            this.calculateTaxAmountSection();
            this.setState({ selectedBatches: [], selectedExpdates: [], selectedQuantities: [] });
        });
    };
    calculateTaxAmountSection = () => {
        let records = this.state.records;
        let totalTaxAmtSec = { ...this.state.totalTaxAmtSec };
    
        // Initialize tax amounts and totals for each tax rate
        let taxSummary = {
          5: { cgstAmt: 0.0, sgstAmt: 0.0, igstAmt:0.0, taxAmt: 0.0, sub_total: 0.0 },
          12: { cgstAmt: 0.0, sgstAmt: 0.0,igstAmt:0.0, taxAmt: 0.0, sub_total: 0.0 },
          18: { cgstAmt: 0.0, sgstAmt: 0.0,igstAmt:0.0, taxAmt: 0.0, sub_total: 0.0 },
        };
    
    
        records.forEach((data) => {
          const taxRate = data.taxrate||data.igst;
    console.log("tax rate",taxRate);
    
          if (taxSummary[taxRate]) {
            console.log("Current Summary for Rate:", taxRate, taxSummary[taxRate]);
    
            taxSummary[taxRate].cgstAmt += Number(data.cgstAmt) || 0;
            taxSummary[taxRate].sgstAmt += Number(data.sgstAmt) || 0;
            taxSummary[taxRate].igstAmt += Number(data.igstAmt) || 0;
            taxSummary[taxRate].taxAmt += Number(data.cgstAmt) + Number(data.sgstAmt) + Number(data.igstAmt)|| 0;
            taxSummary[taxRate].sub_total += Number(data.sub_total) || 0;
    
            console.log("Updated Summary for Rate:", taxRate, taxSummary[taxRate]);
          }
        });
    
        // Ensure totalTaxAmtSec has the necessary properties initialized
        totalTaxAmtSec = {
          cgstAmt5: totalTaxAmtSec.cgstAmt5 || 0,
          sgstAmt5: totalTaxAmtSec.sgstAmt5 || 0,
          igstAmt5: totalTaxAmtSec.igstAmt5 || 0,
          taxAmt5: totalTaxAmtSec.taxAmt5 || 0,
          sub_total5: totalTaxAmtSec.sub_total5 || 0,
          cgstAmt12: totalTaxAmtSec.cgstAmt12 || 0,
          sgstAmt12: totalTaxAmtSec.sgstAmt12 || 0,
          igstAmt12: totalTaxAmtSec.igstAmt12 || 0,
          taxAmt12: totalTaxAmtSec.taxAmt12 || 0,
          sub_total12: totalTaxAmtSec.sub_total12 || 0,
          cgstAmt18: totalTaxAmtSec.cgstAmt18 || 0,
          sgstAmt18: totalTaxAmtSec.sgstAmt18 || 0,
          igstAmt12: totalTaxAmtSec.igstAmt12 || 0,
          taxAmt18: totalTaxAmtSec.taxAmt18 || 0,
          sub_total18: totalTaxAmtSec.sub_total18 || 0,
        };
    
    
    
        // Update the totalTaxAmtSec object with calculated values
        totalTaxAmtSec.cgstAmt5 = taxSummary[5].cgstAmt;
        totalTaxAmtSec.sgstAmt5 = taxSummary[5].sgstAmt;
        totalTaxAmtSec.igstAmt5 = taxSummary[5].igstAmt;
        totalTaxAmtSec.taxAmt5 = taxSummary[5].taxAmt;
        totalTaxAmtSec.sub_total5 = taxSummary[5].sub_total;
    
        totalTaxAmtSec.cgstAmt12 = taxSummary[12].cgstAmt;
        totalTaxAmtSec.sgstAmt12 = taxSummary[12].sgstAmt;
        totalTaxAmtSec.igstAmt12 = taxSummary[12].igstAmt;
        totalTaxAmtSec.taxAmt12 = taxSummary[12].taxAmt;
        totalTaxAmtSec.sub_total12 = taxSummary[12].sub_total;
    
        totalTaxAmtSec.cgstAmt18 = taxSummary[18].cgstAmt;
        totalTaxAmtSec.sgstAmt18 = taxSummary[18].sgstAmt;
        totalTaxAmtSec.igstAmt18 = taxSummary[18].igstAmt;
        totalTaxAmtSec.taxAmt18 = taxSummary[18].taxAmt;
        totalTaxAmtSec.sub_total18 = taxSummary[18].sub_total;
    
        console.log("Final Total Tax Amount Section:", totalTaxAmtSec);
    
        // Update the state with the new total tax amounts
        this.setState({ totalTaxAmtSec });
      };
      clearBatches = () => {
        this.setState({
           
            selectedBatches: [],
        }, () => {
            console.log("Batches and selected batches cleared.");
        });
      };
    handleBatchClose = () => {
        this.clearBatches(); // Clear batches when modal is closed
        this.setState({ showModel: false });
      };
    clearErrors = (errors) => {


        errors.address = ""
        errors.created_by = ""
        errors.voucher_no = ""
        errors.voucher_date = ""
        errors.invoice_date = ""
        errors.remarks = ""
        errors.vendorinvoice_no = ""
        errors.poref_no = ""
        return errors
    }

    cancel = () => {

        let data = this.state.purchaseEntryData;

        data.id = ""
        data.user_id = ""

        data.vendor_name = {
            label: "", value: ""
        }
        data.address = ""
        data.created_by = ""
        data.voucher_no = ""
        data.voucher_date = ""
        data.invoice_date = ""
        data.remarks = ""
        data.vendorinvoice_no = ""
        data.poref_no = ""


        let errors = this.state.errors;

        errors = this.clearErrors(errors);

        this.setState({
            purchaseEntryData: data, actions: "add", voucher_no: "", errors: errors, searchErrorMessage: "", records: [],
            search_action: false,
            totalAmtSec: {
                discAmt: 0,
                cgstAmt: 0,
                sgstAmt: 0,
                igstAmt: 0,
                total: 0,
                sub_total: 0,

            },

        });
    }

    clearimport = () => {
        this.setState({ file: "" });
    };

    clearMessage = () => {
        setTimeout(() => this.setState({
            formSuccess: { message: "", },
            tableSuccess: { message: "" }
        }), 5000);
    }

    /*  calculateSection = () => {
       let records = this.state.records;
       let totalAmtSec = this.state.totalAmtSec;
       let amt = 0.0;
       let taxAmt = 0.0;
       let taxVal = 0.0;
       let totalAmt = 0.0;
       let sub_total=0.0;
      console.log(records);
   
       records.map((data, i) => {
         if (undefined !== data.fee) {
           amt = Number(amt) + Number(data.fee);
         }
         if (undefined !== data.gst_amount) {
           taxAmt = Number(taxAmt) + Number(data.gst_amount);
         }
         if (undefined !== data.taxable_value) {
           taxVal = Number(taxVal) + Number(data.taxable_value);
         }
         if (undefined !== data.total_amount) {
           totalAmt = Number(totalAmt) + Number(data.total_amount);
         }
         if (undefined !== data.quantity) {
           sub_total = Number(data.quantity) * Number(data.p_rate);
         }
       });
   
       totalAmtSec.amt = amt;
       totalAmtSec.taxAmt = taxAmt;
       totalAmtSec.taxVal = taxVal;
       totalAmtSec.totalAmt = totalAmt;
       totalAmtSec.sub_total=sub_total;
       totalAmtSec.totalAmtWords = converter.toWords(totalAmt)+" rupees only";
       this.setState({ totalAmtSec });
   
       console.log(totalAmtSec);
     }; 
    */

    calculateSection = () => {
        let records = this.state.records;
        let totalAmtSec = { ...this.state.totalAmtSec };

        let discAmt = 0.0;
        let cgstAmt = 0.0;
        let sgstAmt = 0.0;
        let igstAmt = 0.0;
        let total = 0.0;
        let sub_total = 0.0;
        let gstAmt = 0.0;
        let roundtotal = 0.0;
        let rounddiff = 0.0;
        console.log(records);

        records.forEach((data, i) => {

            if (data.discAmt !== undefined) {
                discAmt += Number(data.discAmt);
            }
            if (data.cgstAmt !== undefined) {
                cgstAmt += Number(data.cgstAmt);
            }
            if (data.sgstAmt !== undefined) {
                sgstAmt += Number(data.sgstAmt);
            }
            if (data.igstAmt !== undefined) {
                igstAmt += Number(data.igstAmt);
            }
            if (data.gstAmt !== undefined) {
                gstAmt += Number(data.gstAmt);
              }
            if (data.total !== undefined) {
                total += Number(data.total);
            }
            if (data.sub_total !== undefined) {
                sub_total += Number(data.sub_total); // Sum up the sub_total for all records
            }
        });

        totalAmtSec.discAmt = discAmt;
        totalAmtSec.cgstAmt = cgstAmt;
        totalAmtSec.sgstAmt = sgstAmt;
        totalAmtSec.igstAmt = igstAmt;
        totalAmtSec.gstAmt = Number(igstAmt)+Number(cgstAmt)+Number(sgstAmt);
        totalAmtSec.total = total;
        totalAmtSec.sub_total = sub_total;
        totalAmtSec.roundtotal = Math.round(total);
        totalAmtSec.rounddiff = total - totalAmtSec.roundtotal;
        totalAmtSec.totalAmtWords = converter.toWords(total) + " rupees only";

        this.setState({ totalAmtSec });

        console.log(totalAmtSec);
    };

    addExpiryBreakageReturnData() {


        let { purchaseReturnData, errors } = this.state;
        purchaseReturnData.type = "ExpiryBreakageReturnData";
        errors = Validation(purchaseReturnData, errors);
        this.setState({ errors: errors });

        if (errors.formIsValid) {
            this.setState({ loading: true });

            let data = {
                user_id: this.props.userdata.id,
                vendor_name: purchaseReturnData.vendor_name.label,
                address: purchaseReturnData.address,
                created_by: purchaseReturnData.created_by,
                remarks: purchaseReturnData.remarks,
                dn_date: purchaseReturnData.dn_date,
                vendorinvoice_no: purchaseReturnData.vendorinvoice_no,
                records: this.state.records,
                subtotalAmount: this.state.totalAmtSec.sub_total.toFixed(2),
                totalAmount:this.state.totalAmtSec.total.toFixed(2),
                discountAmt: this.state.totalAmtSec.discAmt.toFixed(2),
                cgstAmt: this.state.totalAmtSec.cgstAmt.toFixed(2),
                sgstAmt: this.state.totalAmtSec.sgstAmt.toFixed(2),
                igstAmt:this.state.totalAmtSec.igstAmt.toFixed(2),
                dn_type:'expirybreakagereturn',
            };
            console.log(data);
            let records = this.state.records;

            axios

                .post(addExpiryBreakageReturnData, data, CONFIG)
                .then((addVendorResponse) => {
                    let res = addVendorResponse.data;
                    console.log(res)
                    if (res.status === "1") {
                        //  console.log(res.data[0].voucher_no);

                        this.setState({
                            records: records,
                            searchTableSuccess: res,
                            loading: false,
                            editformSuccess: res,
                            expirybreakagereturn_no: res.data[0].expirybreakagereturn_no
                        });
                        toast.success("The Expiry Breakage Return voucher have been added successfully.", {
                            className: "toast-success"
                        });
                        this.clearMessage();
                        //this.clearAll();
                    } else {
                        this.setState({
                            searchrecords: records,
                            searchTableSuccess: res,
                            editformSuccess: res,
                            loading: false,
                        });
                        toast.error("Expiry Breakage Return voucher could not be Added. ", {
                            className: "toast-error"
                        });
                        this.clearMessage();
                    }
                })
                .catch(() => { });

        }
    }

    handlePlaceSelect() {
        let place = this.autocomplete.getPlace();

        let { purchaseReturnData } = this.state;

        var componentForm = {
            street_number: "long_name",
            administrative_area_level_1: "long_name",
            locality: "long_name",
            country: "long_name",
            sublocality_level_1: "long_name",
            postal_code: "long_name",
        };
        console.log(place);
        purchaseReturnData.address = place.formatted_address;


        this.setState({
            purchaseReturnData,
        });
    }
    componentDidMount = () => {
        this.autocomplete = new google.maps.places.Autocomplete(
            document.getElementById("address"),
            {}
        );
        this.autocomplete.addListener("place_changed", this.handlePlaceSelect);


        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${this.props.access_token}`;
        axios
            .post(getAllPharmacyItemList, { user_id: this.props.userdata.id }, CONFIG)
            .then((result) => {
                let supplies = result.data.data;
                console.log(supplies);
                //to rename json key object
                supplies.forEach((obj) => renameKey(obj, "drug_id", "value"));
                supplies.forEach((obj) => renameKey(obj, "generic_name", "label"));

                //set first record as consultation fee by default
                /*  let consultation_fee_record = {};
                 consultation_fee_record.s_no = 1;
                 consultation_fee_record.description = "Consultation Fee";
                 consultation_fee_record.fee = completion_data.consultation_fee.replace(/[^0-9]/g, '');
                 consultation_fee_record.disc = "";
                 consultation_fee_record.taxable_value = "";
                 consultation_fee_record.gst_rate = "";
                 consultation_fee_record.gst_amount = "";
                 consultation_fee_record.total_amount = completion_data.consultation_fee.replace(/[^0-9]/g, '');
       */
                let records = [];
                // records.push(consultation_fee_record); 

                let defaultEnterSize = this.state.defaultEnterSize;

                for (let i = 1; i <= defaultEnterSize; i++) {
                    let default_rec = Object.assign({}, record);
                    default_rec.s_no = i;
                    records.push(default_rec);
                }

                this.setState(
                    {
                        supplies: supplies,
                        loading: false,
                        records: records,
                    },
                    () => {
                        this.calculateSection();
                        this.calculateTaxAmountSection();
                    }
                );
            })
            .catch((e) => {
                this.setState({ loading: false });
            });


        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${this.props.access_token}`;

        axios
            .post(getTimeoutbycategory, { category: this.props.userdata.user_type }, CONFIG)
            .then((res) => {
                let data = res.data;
                console.log(res);
                console.log(data);
                console.log(data.data.timeout);
                if (data.status == "1")
                    this.setState({
                        hospitaltimeout: data.data.timeout

                    });
            })
            .catch((e) => { });
        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${this.props.access_token}`;
        axios
            .post(getAllPharmacyVendorList, { user_id: this.props.userdata.id }, CONFIG)
            .then(({ data }) => {
                const mastervendorNameList = data.data;
                const uniqueDrugNames = new Set();
                const mastervendorNames = mastervendorNameList
                    .filter((element) => {

                        if (!uniqueDrugNames.has(element.vendor_name)) {
                            uniqueDrugNames.add(element.vendor_name);
                            return true;
                        }
                        return false;
                    })
                    .map((element) => ({
                        value: element.vendor_id,
                        label: element.vendor_name,

                    }));

                this.setState({ mastervendorNames });
            })
            .catch((error) => {
                console.error("Error fetching drug data:", error);

            });

        axios
            .post(getPharmacyShortDetail, { user_id: this.props.userdata.id }, CONFIG)
            .then((Respons) => {
                let data = Respons.data.data[0];
                console.log(data.state);

                if (data.status == "1")
                    this.setState({
                        State_value: data.state

                    });
            }).catch((e) => { });

          



    };
    onDeleteClick(record) {

        this.setState({ addPopup: true, record: record });
    }
    deleteRecord(record) {

        let userId = record.id;

        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${this.props.access_token}`;
        axios
            .delete(deletePharmacy, { data: { id: userId } }, CONFIG)
            .then((res) => {
                let response = res.data;
                if (response.status === "1") {
                    let records = this.state.records;
                    const deleteIndex = records
                        .map((item) => item.id)
                        .indexOf(record.id);
                    records.splice(deleteIndex, 1);
                    this.setState({ records });
                }
                this.setState({ addPopup: false, record: "" });
                toast.error("The Pharmacy detail has been deleted successfully.", {
                    className: "toast-error"
                });
                //  this.setState({ tableSuccess: res.data });
                this.clearMessage();
                this.cancel();
            })
            .catch((e) => { });
    }
    deleteElementsUpToIndex(array, index) {
        // Check if the index is valid
        if (index < 0 || index >= array.length) {
            console.error("Invalid index");
            return array; // Return the original array if the index is invalid
        }
        
        // Return a new array starting from the specified index
        return array.slice(index);
    }
    onFileUpload = () => {

        if (this.state.OpeningStockData.length) {
            axios.post(openingstockimport, { data: this.state.OpeningStockData, user_id: this.props.userdata.id }).then((result) => {
                console.log(result);
                console.log(result.data.message);
                this.setState({ formSuccess: result.data.message, file: "", OpeningStockData: [] });
                if (result.data.status = '1') {
                    toast.success(result.data.message, {
                        className: "toast-success"
                    });
                } else {
                    toast.error(result.data.message, {
                        className: "toast-error"
                    });

                }
                this.clearMessage();
            });
        }

    };
    formatDateForInput = (dateString) => {
        // Convert "YYYY-MM-DD HH:mm:ss" to "YYYY-MM-DD"
        return dateString.split(' ')[0]; // Extract just the date part
    };
    /*  handleselectChange = (index, key) => selectedOption => {
      
       // Create a copy of the current table data
       let updatedData = [...this.state.records];
       
       // Update the specific row's key with the selected option value
       updatedData[index][key] = selectedOption ? selectedOption.label : "";
   
       // Set the state with the updated data
       this.setState({ records: updatedData });
   
       axios
       .post(getitemlistforPharmacyDrug,{user_id:this.props.userdata.id,drug_name:selectedOption.label}, CONFIG)
       .then((drugRespons) => {
         let ItemList = drugRespons.data.data;
       
         ItemList.forEach((element, index) => {
           ItemList.push({
            
             pack:element.pack,
             cgst: element.cgst,
             sgst:element.sgst,
             igst:element.igst
             
           });
           let records = this.state.records;
           var recIndex = findWithAttr(records, "s_no", record.s_no);
           if (null != record) {
           
             records[recIndex].pack = element.unit_of_measure;
             records[recIndex].cgst = element.cgst + " %";
             records[recIndex].gst_amount =
               (record.tax_percentage / 100) * record.amount;
             records[recIndex].total_amount =
               Number(records[recIndex].fee) +
               Number(records[recIndex].gst_amount);
           } else {
            
             records[recIndex].fee = "";
             records[recIndex].gst_rate = "";
             records[recIndex].gst_amount = "";
             records[recIndex].total_amount = "";
           }
     
           console.log(recIndex);
           console.log(records.length - 1);
           if (recIndex === records.length - 1) {
             let default_rec = Object.assign({}, record);
             default_rec.s_no = records.length + 1;
             records.push(default_rec);
           }
     
         });
        
       })
          
         
   
     
   
   
     }; */

    /*   handleselectChange = (index, key) => selectedOption => {
        // Create a copy of the current table data
        let updatedData = [...this.state.records];
        
        // Update the specific row's key with the selected option value
        updatedData[index][key] = selectedOption ? selectedOption.label : "";
    
        // Set the state with the updated data
        this.setState({ records: updatedData });
    
         axios
        .post(getPharmacyShortDetail,{user_id:this.props.userdata.id}, CONFIG)
        .then((Respons) => {
          let data = Respons.data.data[0];
          console.log(data.state);
       
          if (data.status == "1")
            this.setState({
           State_value:data.state
    
            });
        }).catch((e) => { });
      
    
        // Post request to fetch item details
        axios
        .post(getitemlistforPharmacyDrug, { user_id: this.props.userdata.id, drug_name: selectedOption.label }, CONFIG)
        .then((drugResponse) => {
            let itemList = drugResponse.data.data;
            console.log(itemList); // Verify the API response
    
            // Ensure the API response contains the `pack` value
            let item = itemList.find(item => item.drug_name === selectedOption.label);
            if (item) {
                // Update the specific row with additional details
                updatedData[index] = {
                    ...updatedData[index],
                    pack: item.unit_of_measure,
                    cgst: this.state.State_value === this.state.gst_state ? item.cgst + " %" : "",
                    sgst: this.state.State_value === this.state.gst_state ? item.sgst + " %" : "",
                    igst: item.igst + " %",
                    sub_total:updatedData[index].quantity*(updatedData[index].p_rate-(updatedData[index].disc*updatedData[index].p_rate)),
                   // gst_amount: (updatedData[index].tax_percentage / 100) * updatedData[index].amount,
                  //  total_amount: Number(updatedData[index].fee) + Number(updatedData[index].gst_amount)
                };
                console.log(updatedData[index]); // Verify the updated record
            }
    
            // Set the state with the updated records
            this.setState({ records: updatedData });
        })
        .catch((error) => {
            console.error("Error fetching item details:", error);
        });
    }; */

    /*   handleselectChange = (index, key) => selectedOption => {
        // Create a copy of the current table data
        let updatedData = [...this.state.records];
        
        // Update the specific row's key with the selected option value
        updatedData[index][key] = selectedOption ? selectedOption.label : "";
    
        // Set the state with the updated data
        this.setState({ records: updatedData });
    
        // Fetch the state value
        axios
        .post(getPharmacyShortDetail, { user_id: this.props.userdata.id }, CONFIG)
        .then((response) => {
            let data = response.data.data[0];
          
            if (response.data.status == "1") {
                this.setState({ State_value: data.state }, () => {
                    // Fetch item details after state is updated
                      console.log(this.state.gst_state);
    
                    axios
                    .post(getitemlistforPharmacyDrug, { user_id: this.props.userdata.id, drug_name: selectedOption.label }, CONFIG)
                    .then((drugResponse) => {
                        let itemList = drugResponse.data.data;
                        console.log(itemList); // Verify the API response
    
                        // Ensure the API response contains the `pack` value
                        let item = itemList.find(item => item.drug_name === selectedOption.label);
                        if (item) {
                            // Update the specific row with additional details
                            updatedData[index] = {
                                ...updatedData[index],
                                pack: item.unit_of_measure,
                                cgst: this.state.State_value === this.state.gst_state ? item.cgst + " %" : "",
                                sgst: this.state.State_value === this.state.gst_state ? item.sgst + " %" : "",
                                igst: item.igst + " %",
                                sub_total: updatedData[index].quantity * (updatedData[index].p_rate - (updatedData[index].disc * updatedData[index].p_rate)),
                            };
                            console.log(updatedData[index]); // Verify the updated record
                        }
    
                        // Set the state with the updated records
                        this.setState({ records: updatedData });
                    })
                    .catch((error) => {
                        console.error("Error fetching item details:", error);
                    });
                });
            }
        })
        .catch((error) => {
            console.error("Error fetching state details:", error);
        });
    }; */

    handleselectChange = (index, key) => selectedOption => {
        // Create a copy of the current table data
        let updatedData = [...this.state.records];
        const drugNameToSet = selectedOption ? selectedOption.label : ''; // Get the selected drug name
        const batch_no=updatedData[index].batch_no?updatedData[index].batch_no:'';
        // Update the drug_name for the specific record
        updatedData[index].generic_name = drugNameToSet;
    
    
        // Update the specific row's key with the selected option value
        updatedData[index][key] = selectedOption ? selectedOption.label : "";
        console.log(updatedData[index][key])
        // Set the state with the updated data
        this.setState({ records: updatedData, selectedBatches: [], batches: [] });
    
        // Fetch the state value
        axios
          .post(getPharmacyShortDetail, { user_id: this.props.userdata.id }, CONFIG)
          .then((response) => {
            let data = response.data.data[0];
    
    
            if (response.data.status === "1") {
              this.setState({ State_value: data.state }, () => {
                // Fetch item details after state is updated
                console.log("State : ", this.state.State_value);
                console.log("GST State: ", this.state.gst_state);
                this.fetchItemDetails(index, selectedOption);
                this.getBatchandExpDateBydrugname(index, selectedOption,new Date());
            if(batch_no!=='')
            {
                this.getalldetailsBygenericnameandbatchno(index,selectedOption,batch_no,new Date());
           
            }
              });
            }
          })
          .catch((error) => {
            console.error("Error fetching state details:", error);
          });
      };
      getalldetailsBygenericnameandbatchno = (index, selectedOption,batch_no) => {

        if (selectedOption != null) {
          this.setState({ batches: [] });
          let updatedData = [...this.state.records];
          let batch_no = updatedData[index].batch_no;
          let generic_name=updatedData[index].generic_name;
          axios.post(getalldetailsBygenericnameandbatchno, { generic_name: generic_name,batch_no:batch_no,specified_date: new Date() }, CONFIG)
            .then((drugResponse) => {
              // Ensure batches is always an array
              let batches = Array.isArray(drugResponse.data.data) ? drugResponse.data.data : [];
              console.log("Fetched batches: ", batches);
              this.setState({ batches,  });
            })
            .catch(error => {
              console.error('Error fetching batch data:', error);
              this.setState({ batches: [],loading:false }); // Set to empty array on error
            });
        }
      }
      getBatchandExpDateBydrugname = (index, selectedOption) => {
        if (selectedOption != null) {
          this.setState({ batches: [] });
          axios.post(getBatchandExpDateBydrugname, { generic_name: selectedOption.label,specified_date: new Date() }, CONFIG)
            .then((drugResponse) => {
              // Ensure batches is always an array
              let batches = Array.isArray(drugResponse.data.data) ? drugResponse.data.data : [];
              console.log("Fetched batches: ", batches);
              this.setState({ batches,  });
            })
            .catch(error => {
              console.error('Error fetching batch data:', error);
              this.setState({ batches: [],loading:false }); // Set to empty array on error
            });
        }
      }
    fetchItemDetails = (index, selectedOption) => {
        axios
            .post(getitemlistforPharmacyDrug, { user_id: this.props.userdata.id, generic_name: selectedOption.label }, CONFIG)
            .then((drugResponse) => {
                let itemList = drugResponse.data.data;
                console.log("Fetched Item List: ", itemList); // Verify the API response

                // Ensure the API response contains the `pack` value
                let item = itemList.find(item => item.generic_name === selectedOption.label);
                if (item) {
                    // Create a copy of the current table data again
                    let updatedData = [...this.state.records];

                    // Update the specific row with additional details
                    updatedData[index] = {
                        ...updatedData[index],
                        drug_id: selectedOption.value,
                        pack: item.unit_of_measure,
                        cgst: this.state.State_value === this.state.gst_state ? item.cgst : "",
                        sgst: this.state.State_value === this.state.gst_state ? item.sgst : "",
                        igst: this.state.State_value !== this.state.gst_state ? item.igst : "",
                        sub_total: updatedData[index].quantity * updatedData[index].p_rate,
                        hsn_code:item.hsn_code,
                        conversion_factor:item.conversion_factor
                    };
                    console.log("Updated Record: ", updatedData[index]); // Verify the updated record
                    console.log(updatedData[index].quantity);
                    // Set the state with the updated records
                    this.setState({ records: updatedData });

                }
                this.setState({ record }, () => {
                    this.calculateSection();
                    this.calculateTaxAmountSection();
                });
            })
            .catch((error) => {
                console.error("Error fetching item details:", error);
            });
    };



    handleColumnChange = (record) => {
        record.online_prescription = ("Yes" === record.online_prescription) ? "No" : "Yes";
        this.UpdateColumnChange(record);
    }
    validateMaxLength(name, value, max) {
        let data = this.state.purchaseReturnData;
        let errors = this.state.errors;

        if (value.length > max) {
            const value1 = value.slice(0, max);
            errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {
            errors[name] = "";
            data[name] = value;
        }
        this.setState({ purchaseReturnData: data, errors: errors });
    }


    onFileChange = event => {

        // Update the state
        this.setState({ file: event.target.files[0] });
        readXlsxFile(event.target.files[0]).then((rows) => {
            console.log(rows);
            console.log("rows");
            this.setState({ OpeningStockData: rows });
            // `rows` is an array of rows
            // each row being an array of cells.
        })

    };


    handlevendorselectChange = async (selectedOptions, e) => {
        let data = this.state.purchaseReturnData;
        let errors = this.state.errors;
        errors[e.name] = ""
        data[e.name] = selectedOptions;


        this.setState({ purchaseReturnData: data, errors, searchErrorMessage: "" });

        axios
            .post(getAllPharmacyVendorList, { user_id: this.props.userdata.id, vendor_name: selectedOptions.label }, CONFIG)
            .then((Respons) => {
                let resdata = Respons.data;
                let data = resdata.data[0];
                console.log(resdata);

                if (resdata.status == "1") {
                    this.setState({ gst_state: data.gst_state }, () => {
                        console.log("Updated GST State: ", this.state.gst_state);
                    });
                }

            }).catch((e) => { });

            axios
            .post(getvendorshortdetailsbyVendorname, { user_id: this.props.userdata.id,vendor_name:selectedOptions.label }, CONFIG)
            .then((Respons) => {
                let resdata = Respons.data;
                let data = resdata.data[0];
             
             
          
                if (resdata.status == "1")
                           {
                 
               let drug_licence1parsed=JSON.parse(data.drug_licence1);
               let drug_licence2parsed=JSON.parse(data.drug_licence2);
               let drug_licence3parsed=JSON.parse(data.drug_licence3);
               console.log(drug_licence1parsed);
                    this.setState({
                       gst_no:data.gst_no,
                       drug_licence1:drug_licence1parsed.drug_licence1,
                       drug_licence2:drug_licence2parsed.drug_licence2,
                       drug_licence3:drug_licence3parsed.drug_licence3,

                    });
                }
            }).catch((e) => { });




    }
      generate() {
        let { purchaseReturnData, errors } = this.state;
        purchaseReturnData.type = "saleEntryData";
        errors = Validation(purchaseReturnData, errors);
        this.setState({ errors: errors });
    
        if (errors.formIsValid) {
          this.setState({ loading: true });
          let data = {
            user_id: this.props.userdata.id,
              patient_name: purchaseReturnData.patient_name || this.state.patient_name,
            address: purchaseReturnData.address || this.state.patient_address,
            remarks: purchaseReturnData.remarks,
            dn_date: purchaseReturnData.dn_date,
             created_by: purchaseReturnData.created_by,
            records: this.state.records
          };
          console.log(data);
        //  console.log(this.state.purchasereturn_no);
        //  console.log(this.state.purchaseReturnData.dn_date);
        //  console.log(this.state.drug_licence1);
          this.props.history.push({
            pathname: "/expirybreakagereturninvoice/" + this.state.expirybreakagereturn_no,
          });
          this.props.history.replace({
            pathname: "/expirybreakagereturninvoice/" + this.state.expirybreakagereturn_no,
            state: {
                expirybreakagereturn_no: this.state.expirybreakagereturn_no,
              dn_date: this.state.purchaseReturnData.dn_date.toString(),
              vendor_name: this.state.purchaseReturnData.vendor_name.label,
              address: this.state.purchaseReturnData.address,
              sub_total: this.state.totalAmtSec.sub_total.toFixed(2),
              gst_no:this.state.gst_no,
              drug_licence1:this.state.drug_licence1,
              drug_licence2:this.state.drug_licence2,
              drug_licence3:this.state.drug_licence3,

               gstAmt: this.state.totalAmtSec.gstAmt.toFixed(2), 
               discAmt: this.state.totalAmtSec.discAmt.toFixed(2),
              total: this.state.totalAmtSec.total.toFixed(2),
              totalAmtWords: this.state.totalAmtSec.totalAmtWords,
              roundtotal: this.state.totalAmtSec.roundtotal.toFixed(2),
              rounddiff: this.state.totalAmtSec.rounddiff.toFixed(2),
              sub_total5: this.state.totalTaxAmtSec.sub_total5,
              cgstAmt5: this.state.totalTaxAmtSec.cgstAmt5,
              sgstAmt5: this.state.totalTaxAmtSec.sgstAmt5,
              igstAmt5: this.state.totalTaxAmtSec.igstAmt5,
              taxAmt5: this.state.totalTaxAmtSec.taxAmt5,
              sub_total12: this.state.totalTaxAmtSec.sub_total12,
              cgstAmt12: this.state.totalTaxAmtSec.cgstAmt12,
              sgstAmt12: this.state.totalTaxAmtSec.sgstAmt12,
              igstAmt12: this.state.totalTaxAmtSec.igstAmt12,
              taxAmt12: this.state.totalTaxAmtSec.taxAmt12,
              sub_total18: this.state.totalTaxAmtSec.sub_total18,
              cgstAmt18: this.state.totalTaxAmtSec.cgstAmt18,
              sgstAmt18: this.state.totalTaxAmtSec.sgstAmt18,
              igstAmt18: this.state.totalTaxAmtSec.igstAmt18,
              taxAmt18: this.state.totalTaxAmtSec.taxAmt18, 
            }
          });
        }
      }
      componentWillUnmount() { this._isMounted = false; }
    render() {

        let PopupClose = () => this.setState({ addPopup: false });
        let PopupConfirm = () => this.deleteRecord(this.state.record);
        let PopupHospitalClose = () => {
            this.setState({ hospitalpopup: true })

        };
        const { purchaseReturnData,batches,showModel, OpeningStockData, records, errors, formSuccess, tableSuccess, hospitaltimeout, mastervendorNames, gst_state, State_value, searchErrorMessage, searchTableSuccess, loading } = this.state;
        const formattedSubTotal12 = this.state.totalTaxAmtSec.sub_total12.toFixed(2);
        return (

            <div className="col-sm-12">
                <IdleTimeOutModal
                    showModal={this.state.showModal}
                    handleClose={this.handleClose}
                    handleLogout={this.handleLogout}
                />
                 <PurchaseReturnSelectModal
                          show={showModel}
                          handleBatchClose={this.handleBatchClose}
                          batches={batches}
                          selectBatch={this.selectBatch}
                          
                        //selectedBatch={selectedBatch}
                        //handleSelectBatchClick={this.handleSelectBatchClick}
                        />
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    element={document}
                    onActive={this.onActive}
                    onIdle={this.onIdle}
                    onAction={this.onAction}
                    debounce={250}
                    timeout={hospitaltimeout} />
                <div className="main-content bacfot">
                    <ToastContainer position="bottom-center" hideProgressBar={true} autoClose={2000} closeOnClick={false} pauseOnHover />

                    <div className="mainpage">
                        <Header user_id={this.props.userdata.id} />
                        <div className="main-box">
                            <div className="sidemenu pr0">
                                <BusinessUserSideBar />
                            </div>
                            {
                                (this.state.adminstatus !== "" && this.state.adminstatus === "Pending") ? (
                                    <div className="container-fluid">
                                        <div className="checkout-tabs">

                                            <div className="row">
                                                <div className="col-sm-12 pr0">
                                                    <div className="card">
                                                        <div className="card-body a-page-1-hight-right ">
                                                            {/* Admin not approved your account yet to view this page. Please contact the administrator to approve your account. */}
                                                            <Popupinfo
                                                                show={!this.state.hospitalpopup}
                                                                onHide={PopupHospitalClose}
                                                                title={"Alert!!"}
                                                                message={"Your Account is now waiting for our approval. Kindly contact the administrator to approve your request."}
                                                            />
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>) :
                                    (


                                        <section className="main-body hospital-profilegap">
                                            <div className="container-fluid">
                                                <div className="row checkout-tabs">
                                                    <div className="col-sm-12">
                                                        <h4 className="font-weight-bold">  Expiry/Breakage Return Voucher </h4>
                                                    </div>
                                                    <div className="col-sm-12 pr0">
                                                        <div className="card b-12-hite">
                                                            <div class="card-header">
                                                                <div class="card-title text-center fs-2">
                                                                    Expiry/Breakage Return Voucher
                                                                </div>

                                                            </div>
                                                            <div className="card-body">
                                                                <div className="user-notification">
                                                                    <SpanField
                                                                        classname={('0' == formSuccess.status) ? "text-danger user-notification" :
                                                                            "text-success user-notification"}
                                                                        title={formSuccess.message}
                                                                    />
                                                                </div>
                                                                <div>



                                                                    <div className="row">
                                                                        {/* <div className="solid">     */}
                                                                        <div className="col-sm-6">
                                                                            <div className="frllftfull">
                                                                                <div className="form-group frllft mbbre">
                                                                                    <Label title="Vendor Name" isMandatory={true} />
                                                                                </div>
                                                                                <div className="form-group frlrit">
                                                                                    <div className="position-relative">
                                                                                        <div className="input-group">
                                                                                            <Select maxMenuHeight={120}
                                                                                                className="selectcls p-0"
                                                                                                name="vendor_name"
                                                                                                isMandatory={true}
                                                                                                value={purchaseReturnData.vendor_name}
                                                                                                onChange={this.handlevendorselectChange}
                                                                                                options={mastervendorNames}
                                                                                            />
                                                                                        </div>
                                                                                        <SpanField
                                                                                            classname="text-danger"
                                                                                            title={errors.pharmacy_name}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="frllftfull">
                                                                                <div className="form-group frllft mbbre">
                                                                                    <Label title="Address" isMandatory={true} />
                                                                                </div>
                                                                                <div className="form-group frlrit">
                                                                                    <div className="position-relative">
                                                                                        <div className="input-group">
                                                                                            <InputField
                                                                                                inputType={"text"}
                                                                                                name={"address"}
                                                                                                controlFunc={this.handleAdd}
                                                                                                content={purchaseReturnData.address || ''}
                                                                                                placeholder={""}
                                                                                                id="address"
                                                                                                max={50}
                                                                                            />
                                                                                        </div>
                                                                                        <SpanField
                                                                                            classname="text-danger"
                                                                                            title={errors.address}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="frllftfull">
                                                                                <div className="form-group frllft mbbre">
                                                                                    <Label title="Created By" isMandatory={true} />
                                                                                </div>
                                                                                <div className="form-group frlrit">
                                                                                    <div className="position-relative">
                                                                                        <div className="input-group">
                                                                                            <InputField
                                                                                                inputType={"text"}
                                                                                                name={"created_by"}
                                                                                                controlFunc={this.handleAdd}
                                                                                                content={purchaseReturnData.created_by || ''}
                                                                                                placeholder={""}
                                                                                                max={50}
                                                                                            />
                                                                                        </div>
                                                                                        <SpanField
                                                                                            classname="text-danger"
                                                                                            title={errors.created_by}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="frllftfull">
                                                                                <div className="form-group frllft ">
                                                                                    <Label title="Remarks" isMandatory={true} />
                                                                                </div>
                                                                                <div className="form-group frlrit">
                                                                                    <div className="position-relative">
                                                                                        <div className="input-group">
                                                                                            <InputField
                                                                                                inputType={"text"}
                                                                                                name={"remarks"}
                                                                                                controlFunc={this.handleAdd}
                                                                                                content={purchaseReturnData.remarks || ''}
                                                                                                placeholder={""}
                                                                                                max={200}
                                                                                            />
                                                                                        </div>
                                                                                        <SpanField
                                                                                            classname="text-danger"
                                                                                            title={errors.remarks}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-sm-6">
                                                                            <div className="frllftfull">
                                                                                <div className="form-group frllft mbbre">
                                                                                    <Label title="DN No" isMandatory={true} />
                                                                                </div>
                                                                                <div className="form-group frlrclfgf">
                                                                                    <div className="position-relative">
                                                                                        <div className="input-group">
                                                                                            <InputField
                                                                                                inputType={"text"}
                                                                                                name={"expirybreakagereturn_no"}
                                                                                                controlFunc={this.handleAdd}
                                                                                                content={this.state.expirybreakagereturn_no || ''}
                                                                                                readOnly={true}
                                                                                                placeholder={""}
                                                                                                max={50}
                                                                                            />
                                                                                        </div>
                                                                                        <SpanField
                                                                                            classname="text-danger"
                                                                                            title={errors.expirybreakagereturn_no}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="form-group frlrclfgf-1">
                                                                                    <Label title="DN Date" isMandatory={true} />
                                                                                </div>
                                                                                <div className="form-group frlrclfgf">
                                                                                    <div className="position-relative">
                                                                                        <div className="input-group">
                                                                                            <DatePicker
                                                                                                className="form-control"
                                                                                                value={purchaseReturnData.dn_date}
                                                                                                format="dd-MM-yyyy"
                                                                                                onChange={(date) => this.handleDatePickerChange(date, 'dn_date')}
                                                                                                yearPlaceholder='YYYY'
                                                                                                monthPlaceholder='MM'
                                                                                                dayPlaceholder='DD'

                                                                                            />
                                                                                        </div>
                                                                                        <SpanField
                                                                                            classname="text-danger"
                                                                                            title={errors.dn_date}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <div className="frllftfull">
                                                                                <div className="form-group frllft mbbre">
                                                                                    <Label title="Vendor Invoice.no" isMandatory={true} />
                                                                                </div>
                                                                                <div className="form-group frlrclfgf">
                                                                                    <div className="position-relative">
                                                                                        <div className="input-group">
                                                                                            <InputField
                                                                                                inputType={"text"}
                                                                                                name={"vendorinvoice_no"}
                                                                                                controlFunc={this.handleAdd}
                                                                                                content={purchaseReturnData.vendorinvoice_no || ''}
                                                                                                placeholder={""}
                                                                                                max={50}
                                                                                            />
                                                                                        </div>
                                                                                        <SpanField
                                                                                            classname="text-danger"
                                                                                            title={errors.vendorinvoice_no}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                {/*   <div className="form-group frlrclfgf-1">
      <Label title="Invoice Date" isMandatory={true} />
    </div>
    <div className="form-group frlrclfgf">
      <div className="position-relative">
        <div className="input-group">
        <DatePicker
            className="form-control"
            value={purchaseEntryData.invoice_date}
            format="dd-MM-yyyy"
            onChange={(date) => this.handleDatePickerChange(date, 'invoice_date')} 
            yearPlaceholder='YYYY'
            monthPlaceholder='MM'
            dayPlaceholder='DD'
           
          />         
        </div>
        <SpanField
          classname="text-danger"
          title={errors.invoice_date}
        />
      </div>
    </div> */}
                                                                            </div>
                                                                            {/* <div className="frllftfull">
                                                                                <div className="form-group frllft mbbre">
                                                                                    <Label title="Mode" isMandatory={true} />
                                                                                </div>
                                                                                <div className="form-group frlrclfgf">
                                                                                    <div className="position-relative">
                                                                                        <div className="input-group">
                                                                                            <InputField
                                                                                                inputType={"text"}
                                                                                                name={"mode"}
                                                                                                controlFunc={this.handleAdd}
                                                                                                content={purchaseReturnData.mode || ''}
                                                                                                placeholder={""}
                                                                                                max={50}
                                                                                            />
                                                                                        </div>
                                                                                        <SpanField
                                                                                            classname="text-danger"
                                                                                            title={errors.mode}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div> */}
                                                                        </div>
                                                                        {/* </div>    */}

                                                                        <div className="col-sm-12">
                                                                            <div className="card ">
                                                                                <div className="card-body ">
                                                                                    <div
                                                                                        className="tab-content"
                                                                                        id="v-pills-tabContent"
                                                                                    >


                                                                                        <div
                                                                                            className="tab-pane fade show active"
                                                                                            id="v-pills-shipping"
                                                                                            role="tabpanel"
                                                                                            aria-labelledby="v-pills-shipping-tab"
                                                                                        >
                                                                                            <div className="user-notification">
                                                                                                <SpanField
                                                                                                    classname={
                                                                                                        "0" === tableSuccess.status
                                                                                                            ? "text-danger user-notification"
                                                                                                            : "text-success user-notification"
                                                                                                    }
                                                                                                    title={tableSuccess.message}
                                                                                                />
                                                                                            </div>
                                                                                            <div style={{ overflowY: 'auto' }}>
                                                                                                <ReactDatatable
                                                                                                    key={0}
                                                                                                    config={this.config}
                                                                                                    records={this.state.records}
                                                                                                    columns={this.columns}
                                                                                                    extraButtons={this.extraButtons}
                                                                                                    className="purchaseentrytable table-bordered table-striped kas "

                                                                                                />
                                                                                            </div>
                                                                                            <table
                                                                                                className="right_bill_section"
                                                                                                cellPadding="10%"
                                                                                            >
                                                                                                <tbody>
                                                                                                    <tr>
                                                                                                        <td width="10%" >
                                                                                                            Grand Total
                                                                                                        </td>
                                                                                                        <td
                                                                                                            width="10%"
                                                                                                            className="cellTextRight"
                                                                                                        >
                                                                                                            {this.state.totalAmtSec.total.toFixed(2)}
                                                                                                        </td>
                                                                                                    </tr>



                                                                                                </tbody>
                                                                                            </table>
                                                                                         {/*    <table
                                                                                                className="left_bill_section"
                                                                                                cellPadding="10%"
                                                                                            >
                                                                                                <tbody>
                                                                                                    <tr>
                                                                                                        <td width="10%" >
                                                                                                            Sub Total
                                                                                                        </td>
                                                                                                        <td
                                                                                                            width="10%"
                                                                                                            className="cellTextRight"
                                                                                                        >
                                                                                                            {this.state.totalAmtSec.sub_total.toFixed(2)}
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td width="10%">
                                                                                                            Disc Amt
                                                                                                        </td>
                                                                                                        <td
                                                                                                            width="10%"
                                                                                                            className="cellTextRight"
                                                                                                        >
                                                                                                            {this.state.totalAmtSec.discAmt.toFixed(2)}
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td width="10%" >
                                                                                                            CGST Amt
                                                                                                        </td>
                                                                                                        <td
                                                                                                            width="10%"
                                                                                                            className="cellTextRight"
                                                                                                        >
                                                                                                            {this.state.totalAmtSec.cgstAmt.toFixed(2)}
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td width="10%" >
                                                                                                            SGST Amt
                                                                                                        </td>
                                                                                                        <td
                                                                                                            width="10%"
                                                                                                            colSpan="2"
                                                                                                            className="cellTextRight"
                                                                                                        >
                                                                                                            {this.state.totalAmtSec.sgstAmt.toFixed(2)}
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td width="10%" >
                                                                                                            IGST Amt
                                                                                                        </td>
                                                                                                        <td
                                                                                                            width="10%"
                                                                                                            colSpan="2"
                                                                                                            className="cellTextRight"
                                                                                                        >
                                                                                                            {this.state.totalAmtSec.igstAmt.toFixed(2)}
                                                                                                        </td>
                                                                                                    </tr>


                                                                                                </tbody>
                                                                                            </table> */}
                                                                                            <div className="col-sm-4">
                                                <table
                                                  className="total_bill_section"
                                                  cellPadding="10%"
                                                >

                                                  <tbody>
                                                    <tr>
                                                      <td width="10%" colSpan="2">
                                                        GST
                                                      </td>
                                                      <td
                                                        width="30%"
                                                        className="cellTextRight"
                                                      >
                                                        Taxable Amt
                                                      </td>
                                                      <td
                                                        width="30%"
                                                        className="cellTextRight"
                                                      >
                                                        CGST Amt
                                                      </td>
                                                      <td
                                                        width="30%"
                                                        colSpan="2"
                                                        className="cellTextRight"
                                                      >
                                                        SGST Amt
                                                      </td>
                                                      <td
                                                        width="30%"
                                                        colSpan="2"
                                                        className="cellTextRight"
                                                      >
                                                        IGST Amt
                                                      </td>
                                                      <td
                                                        width="15%"
                                                        className="cellTextRight"
                                                      >
                                                        Tax Amt
                                                      </td>
                                                    </tr>

                                                    <tr>
                                                      <td width="30%" colSpan="2">
                                                        5%
                                                      </td>
                                                      <td
                                                        width="20%"
                                                        className="cellTextRight"
                                                      >
                                                        {this.state.totalTaxAmtSec.sub_total5.toFixed(2)}
                                                      </td>
                                                      <td
                                                        width="15%"
                                                        className="cellTextRight"
                                                      >
                                                        {this.state.totalTaxAmtSec.cgstAmt5.toFixed(2)}
                                                      </td>
                                                      <td
                                                        width="20%"
                                                        colSpan="2"
                                                        className="cellTextRight"
                                                      >
                                                        {this.state.totalTaxAmtSec.sgstAmt5.toFixed(2)}
                                                      </td>
                                                      <td
                                                        width="20%"
                                                        colSpan="2"
                                                        className="cellTextRight"
                                                      >
                                                        {this.state.totalTaxAmtSec.igstAmt5.toFixed(2)}
                                                      </td>
                                                      <td
                                                        width="15%"
                                                        className="cellTextRight"
                                                      >
                                                        {this.state.totalTaxAmtSec.taxAmt5.toFixed(2)}
                                                      </td>
                                                    </tr>

                                                    <tr>
                                                      <td width="30%" colSpan="2">
                                                        12%
                                                      </td>
                                                      <td
                                                        width="20%"
                                                        className="cellTextRight"
                                                      >
                                                        {formattedSubTotal12}
                                                      </td>
                                                      <td
                                                        width="15%"
                                                        className="cellTextRight"
                                                      >
                                                        {this.state.totalTaxAmtSec.cgstAmt12.toFixed(2)}
                                                      </td>
                                                      <td
                                                        width="20%"
                                                        colSpan="2"
                                                        className="cellTextRight"
                                                      >
                                                        {this.state.totalTaxAmtSec.sgstAmt12.toFixed(2)}
                                                      </td>
                                                      <td
                                                        width="20%"
                                                        colSpan="2"
                                                        className="cellTextRight"
                                                      >
                                                        {this.state.totalTaxAmtSec.igstAmt12.toFixed(2)}
                                                      </td>
                                                      <td
                                                        width="15%"
                                                        className="cellTextRight"
                                                      >
                                                        {this.state.totalTaxAmtSec.taxAmt12.toFixed(2)}
                                                      </td>
                                                    </tr>

                                                    <tr>
                                                      <td width="30%" colSpan="2">
                                                        18%
                                                      </td>
                                                      <td
                                                        width="20%"
                                                        className="cellTextRight"
                                                      >
                                                        {this.state.totalTaxAmtSec.sub_total18.toFixed(2)}
                                                      </td>
                                                      <td
                                                        width="15%"
                                                        className="cellTextRight"
                                                      >
                                                        {this.state.totalTaxAmtSec.cgstAmt18.toFixed(2)}
                                                      </td>
                                                      <td
                                                        width="20%"
                                                        colSpan="2"
                                                        className="cellTextRight"
                                                      >
                                                        {this.state.totalTaxAmtSec.igstAmt18.toFixed(2)}
                                                      </td>
                                                      <td
                                                        width="20%"
                                                        colSpan="2"
                                                        className="cellTextRight"
                                                      >
                                                        {this.state.totalTaxAmtSec.sgstAmt18.toFixed(2)}
                                                      </td>
                                                      <td
                                                        width="15%"
                                                        className="cellTextRight"
                                                      >
                                                        {this.state.totalTaxAmtSec.taxAmt18.toFixed(2)}
                                                      </td>
                                                    </tr>

                                                  </tbody>
                                                </table>
                                              </div>

                                                                                            <Popup
                                                                                                show={this.state.addPopup}
                                                                                                onHide={PopupClose}
                                                                                                onConfirm={PopupConfirm}
                                                                                                title={"Confirmation"}
                                                                                                message={
                                                                                                    "Are you sure you want to delete this record ?"
                                                                                                }
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-sm-12">

                                                                            <div className=" float-right mr-2">



                                                                                {/*       <tbody>
                                        <tr>
                                            <td width="40%" colSpan="2">
                                                Sub Total
                                            </td>
                                            <td colSpan="4"></td>
                                            <td className="cellTextRight">
                                                <input
                                                type="text"
                                                value={this.state.totalAmtSec.totalAmt}
                                                onChange={(e) => this.setState({ totalAmtSec: { totalAmt: e.target.value } })}
                                                />
                                            </td>
                                            </tr>
                                            <tr>
                                            <td width="30%" colSpan="2">
                                              Discount Amount
                                            </td>
                                            <td colSpan="4"></td>
                                            <td className="cellTextRight">
                                            <input
                                                type="text"
                                                value={this.state.totalAmtSec.totalAmt}
                                                onChange={(e) => this.setState({ totalAmtSec: { totalAmt: e.target.value } })}
                                                />
                                            </td>
                                          </tr>
                                          

                                          <tr>
                                            <td width="30%" colSpan="2">
                                              CGST%
                                            </td>
                                            <td colSpan="4"></td>
                                            <td className="cellTextRight">
                                            <input
                                                type="text"
                                                value={this.state.totalAmtSec.totalAmt}
                                                onChange={(e) => this.setState({ totalAmtSec: { totalAmt: e.target.value } })}
                                                />
                                            </td>
                                          </tr>
                                          <td width="30%" colSpan="2">
                                              SGST%
                                            </td>
                                            <td colSpan="4"></td>
                                            <td className="cellTextRight">
                                            <input
                                                type="text"
                                                value={this.state.totalAmtSec.totalAmt}
                                                onChange={(e) => this.setState({ totalAmtSec: { totalAmt: e.target.value } })}
                                                />
                                            </td>
                                          
                                          <tr>
                                            <td width="30%" colSpan="2">
                                              Grand Total
                                            </td>
                                            <td colSpan="4"></td>
                                            <td className="cellTextRight">
                                            <input
                                                type="text"
                                                value={this.state.totalAmtSec.totalAmt}
                                                onChange={(e) => this.setState({ totalAmtSec: { totalAmt: e.target.value } })}
                                                />
                                            </td>
                                          </tr>
                                        
                                        </tbody> */}

                                                                            </div>
                                                                        </div>


                                                                    </div>
                                                                </div>
                                                            </div>





                                                            <div>
                                                                <button
                                                                    type="button"
                                                                    style={{ width: 170, float: "right", margin: 20 }}
                                                                    className="signupbtn abtn btdpml hidecontent"
                                                                    onClick={this.addExpiryBreakageReturnData.bind(this)}
                                                                    id="pay"
                                                                >
                                                                    Save
                                                                </button>
                                                                <button
                                  type="button"
                                  style={{ width: 92, float: "right", margin: 20 }}
                                  className="signupbtn abtn btdpml hidecontent"
                                  onClick={this.generate.bind(this)}
                                  id="pay"
                                  disabled={!this.state.expirybreakagereturn_no}
                                >
                                  Generate
                                </button>
                                                                <button
                                                                    type="button"
                                                                    style={{ width: 170, float: "right", margin: 20 }}
                                                                    className="signupbtn abtn btdpml hidecontent"
                                                                    onClick={this.cancel}
                                                                    id="pay"
                                                                >
                                                                    clear
                                                                </button>
                                                            </div>
                                                            {/*   <div className="card">
                                            <div className="card-header"> <div className="card-title">Import Opening Stock</div> </div>
                                                <div className="card-body">
                                                    <div>
                                                      
                                                        <div className="user-notification">
                                                            <SpanField
                                                                classname={
                                                                    "0" === formSuccess.status
                                                                        ? "text-danger user-notification"
                                                                        : "text-success user-notification"
                                                                }
                                                                title={formSuccess.message}
                                                            />
                                                        </div>
                                                        <div className="form-group d-flex justify-content-center mg-btm5">
                                                                    <button
                                                                        ref="btn"
                                                                        href="patients-register"
                                                                        className="signupbtn abtn btdpml btn-margin"
                                                                        onClick={this.onFileUpload}>

                                                                        {loading ? (
                                                                            <LoadingSpinner title="Update" />
                                                                        ) : this.state.actions === "Update" ? (
                                                                            "Upload"
                                                                        ) : (
                                                                            "Upload"
                                                                        )}
                                                                    </button>
                                                                    <button
                                                                        href="patients-register"
                                                                        className="signupbtn abtn btdpml"
                                                                        onClick={this.clearimport}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                </div>
                                                        <div className="float-right btn btn2 "> <OpeningStockTemplate /></div>
                              
                                                        <div className="row">
                                                                
                                                            <div className="col-sm-4" >
                                                                <div className="custom-file text-left">
                                                                    
                                                                    <input accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" type="file" onChange={this.onFileChange} name="file" className="custom-file-input" id="file" />
                                                                    <label className="custom-file-label" htmlFor="file">{this.state.file ? this.state.file.name : ""}</label>
                                                                   
                                                                
                                                                </div>
                                                             
                                                            </div>

                                                       
                                                           
                                                        </div>
                                                    </div>
                                                  {/*   <div className="form-group"><label className="control-label">{this.state.file ? this.state.file.name : ""}</label></div> */}
                                                            {/*  </div>
                                            </div>  */}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </section>)}
                            <FooterSection />

                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExpiryBreakageDNVoucher));

function findWithAttr(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
            return i;
        }
    }
    return -1;
}
